import { render, staticRenderFns } from "./IndexProductsPage.vue?vue&type=template&id=4b7070e4&"
import script from "./IndexProductsPage.vue?vue&type=script&lang=js&"
export * from "./IndexProductsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports